import { fetchData, postData, putData } from "../../utils/apiUtils";
import useGetUserToken from "../../utils/getUserToken";
function usePayrollApi() {
  const token = useGetUserToken();
  const get_payroll = async (month, year) => {
    const url = `employee/payroll/bymonth?month=${encodeURIComponent(
      month
    )}&year=${encodeURIComponent(year)}`;
    const expenseData = await fetchData(url, token);
    return expenseData;
  };
  const get_payroll_employee_list = async () => {
    const url = `employee/payroll/employeelist`;
    const employee_list = await fetchData(url, token);
    return employee_list;
  };

  const get_benefit_list = async () => {
    const url = `employee/benefit/bybranch`;
    const benefit_list = await fetchData(url, token);
    return benefit_list;
  };

  const addBenefit = async (newBenefit) => {
    const url = `employee/benefit/register`;
    const responseData = await postData(url, newBenefit, token);
    return responseData;
  };

  const updateBenefit = async (newBenefit) => {
    const url = `employee/benefit/update`;
    const responseData = await putData(url, newBenefit, token);
    return responseData;
  };

  const get_deduction_list = async () => {
    const url = `employee/deduction`;
    const deduction_list = await fetchData(url, token);
    return deduction_list;
  };

  const addDeduction = async (newDeduction) => {
    const url = `employee/deduction/register`;
    const responseData = await postData(url, newDeduction, token);
    return responseData;
  };

  const updateDeduction = async (newDeduction) => {
    const url = `employee/deduction/update`;
    const responseData = await putData(url, newDeduction, token);
    return responseData;
  };

  return {
    get_payroll,
    get_payroll_employee_list,
    get_benefit_list,
    addBenefit,
    updateBenefit,
    get_deduction_list,
    addDeduction,
    updateDeduction,
  };
}
export default usePayrollApi;
